export var DEFAULT_TIMEZONE = 'America/New_York';
export var DEFAULT_LANGUAGE = 'en';
